import { TReduxActions } from '../../types/redux';
import { IPromoCalculatorState } from '../../types/redux/promoCalculator';

export function promoCalculatorReducer(
  state: IPromoCalculatorState = null,
  action: TReduxActions,
): IPromoCalculatorState {
  return state;
}
